import React from 'react';
import { useDispatch } from 'react-redux';

import { getLister } from '../../actions/lister-actions';

export const BrowseAllProducts = ({ text, link, category }) => {
	const dispatch = useDispatch();

	if (text && link && getLister) {
		return (
			<a
				href={link}
				className="text-cta-action"
				data-tag-name="browse-all-clicked"
				data-tag-category={category}
				data-testid="browseAllLink"
				onClick={(e) => {
					e.preventDefault();
					dispatch(
						getLister(link, {
							type: '',
							trackHistory: true,
						})
					);
				}}
				dangerouslySetInnerHTML={{ __html: text }}
			/>
		);
	}

	return null;
};

export default BrowseAllProducts;
